import React, { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { logout } from '../utils/Auth'
import Topbar from 'components/Topbar'

const Logout = () => {
    const navigate = useNavigate()

    useEffect(() => {
        logout(() => {
            navigate('/')
        })
    }, [])

    return (
        <>
            <Topbar loggingOut={true} />
        </>
    )
}
  
export default Logout